import confetti from 'canvas-confetti';

export function fireConfetti(): void {
  const opts = { particleCount: 80, spread: 70, origin: { y: 0.6 } };
  void confetti({ ...opts, angle: 60, origin: { ...opts.origin, x: 0 } });
  void confetti({ ...opts, angle: 120, origin: { ...opts.origin, x: 1 } });
}
